import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment to enable bookend impressions tracking on product tiles
 */
export const PRODUCT_TILE_BOOKEND_IMPRESSIONS_250828 =
  'PRODUCT_TILE_BOOKEND_IMPRESSIONS_250828' as SettingConst<
    'PRODUCT_TILE_BOOKEND_IMPRESSIONS_250828',
    boolean,
    'RETAILER_ANDROID' | 'RETAILER_IOS' | 'RETAILER'
  >;
